import { render } from "./SuiviRecommandations.vue?vue&type=template&id=6735a92c"
import script from "./SuiviRecommandations.vue?vue&type=script&lang=js"
export * from "./SuiviRecommandations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__